import { render, staticRenderFns } from "./BackendBanner.vue?vue&type=template&id=15c5969c&scoped=true&"
import script from "./BackendBanner.vue?vue&type=script&lang=js&"
export * from "./BackendBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c5969c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBanner,VBtn,VProgressCircular})
